// extracted by mini-css-extract-plugin
export default {"tableContainer":"reports-table_tableContainer__-j4yO","responsiveTable":"reports-table_responsiveTable__LKf6G"};